<template>
   <div class="card mb-0" ref="entidade">
      <div class="card-body position-relative">

         <div class="d-flex align-items-center mb-3">
            <div class="flex-grow-1">
               <h5 class="mb-2 limitador font-18">{{entidade.nome || 'Não informado'}}</h5>
               <p class="mb-1"><small class="text-muted">CNPJ: {{entidade.cnpj || 'Não informado'}}</small></p>
            </div>
            <div class="d-flex align-items-center">
               <div class="dropdown">
                  <button class="btn btn-theme" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-right">
                     <li class="cursor-pointer"><a class="dropdown-item" @click="visualizar()"><i class="far fa-eye mr-2"></i>Visão Detalhada</a></li>
                     <li class="cursor-pointer"><a class="dropdown-item" @click="abrirRelatorio()"><i class="far fa-file-alt mr-2"></i>Relatório</a></li>
                     <li class="dropdown-divider"></li>
                     <li class="cursor-pointer"><a class="dropdown-item" @click="editar()"><i class="fas fa-edit mr-2"></i>Editar</a></li>
                     <li class="cursor-pointer"><a class="dropdown-item" @click="excluir(entidade.id)"><i class="fas fa-trash mr-2"></i>Excluir</a></li>
                  </ul>
               </div>
            </div>
         </div>
         
         <hr class="my-3">
         
         <div class="row g-3">
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">E-mail</small>
                     <span class="limitador">{{entidade.email || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Telefone</small>
                     <span class="limitador">{{entidade.telefone || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Responsável</small>
                     <span class="limitador">{{entidade.nomeResponsavel || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Casos ativos</small>
                     <span class="badge bg-theme text-white mt-1 font-12" style="font-weight: 500;">
                        {{entidade.qtdSentenciados != null ? entidade.qtdSentenciados : 0}} sentenciado(s)
                     </span>
                  </div>
               </div>
            </div>
            <div class="col-12">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Endereço</small>
                     <span class="limitador-mapa text-secondary"><i class="far fa-map-marker-alt text-danger mr-1"></i>{{entidade.endereco || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'Entidade',
   props: ['entidade', 'index'],
   computed: {
      ... mapState({
         urlRest: state => state.urlRest
      })
   },
   methods: {
      ... mapMutations([
         'deslogar'
      ]),
      editar() {
         this.$emit('editar', this.entidade)
      },
      visualizar() {
         this.$emit('visualizar', this.entidade.id)
      },
      abrirRelatorio() {
         this.$emit('imprimir', this.entidade)
      },
      excluir(id) {
         let ref = this;
         Swal.fire({
            title: 'Deseja excluir essa entidade?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true)
               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'entidades/deleteEntidade',
                  params: { id: id }
               }).then(function () {
                  ref.$refs.entidade.style.display = 'none'
                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Entidade excluída!'
                  })
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.deslogar()
                        ref.$toast.fire({ icon: 'warning', title: 'Sessão expirada!' });
                     } else {
                        ref.$toast.fire({ icon: 'error', title: 'Erro: ' + error.response.status })
                     }
                  } else { ref.$toast.fire({ icon: 'error', title: error }) }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               })
            }
         });
      }
   }
}
</script>

<style scoped>
div.top-12 i { font-size: 17px; }
div.top-12 {
   right: 8px;
   cursor: pointer;
}
.body:hover div.top-12 { right: 8px; }
.body:hover div.top-12 span { text-decoration: underline; }
</style>